import React from 'react';
import { Skeleton, Tooltip } from 'antd';
import withTranslations from 'app/components/HOGs/withTranslations';

const PlaceCounter = ({ count = 0, max = 99, tr }) => {
  const num = count > max ? ` (${count})` : '';
  return (
    <Tooltip title={`${tr['Number of Place']}${num}`}>
      {count === 'loading' ? (
        <div className="tour-counter-loading">
          <Skeleton avatar={{ size: 20 }} title={{ width: 0 }} active />
        </div>
      ) : (
        <div className="tour-counter">{count <= max ? count : `${max}+`}</div>
      )}
    </Tooltip>
  );
};
export default withTranslations(PlaceCounter);
